module.exports = __webpack_public_path__ + "img/quizzz-6.c0ec1fee.jpg";